import React from 'react';
import {
    Col, FormGroup, Input, Label,
    Row
} from 'reactstrap';
import {LangController} from "../../../../components/tabs/langController";

const HomeUdnLangs = props => {
    const setDataDefault = (activeLangs, setLangChilds) => {
        const items = activeLangs.map( lang => ({
            id: '',
            lang: { id:lang?.id, name:lang?.name, showOrder: lang?.showOrder },
            slogan: '',
            address: '',
        }) )
        setLangChilds(items);
    }

    const getFormulary = (child, index, disableInputs, onInputChange) => {
        return (<>
            <Row>
                <Col md="12">
                    <FormGroup>
                        <Label>Slogan</Label>
                        <Input type="textarea"
                               name="slogan"
                               rows="2"
                               placeholder="Ingrese slogan"
                               disabled={disableInputs}
                               value={child.slogan}
                               onChange={e => onInputChange(e, child.lang)}
                        />
                    </FormGroup>
                </Col>
                <Col md="12">
                    <FormGroup>
                        <Label>Dirección</Label>
                        <Input type="textarea" name="address"
                               placeholder="Ingrese dirección"
                               value={child.address}
                               onChange={e => onInputChange(e, child.lang)}
                               disabled={disableInputs}
                        />
                    </FormGroup>
                </Col>
            </Row>
        </>)
    }

    return(<LangController
        langs={props.langs}
        setLangs={props.setLangs}
        getFormulary={getFormulary}
        setDataDefault={setDataDefault}
        translatableLangs={props.translatableLangs}
    />)
}

export default HomeUdnLangs
